import React, { useState, useEffect } from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
import DropDown from '@boschebike/ebds-react/dist-esm/components/DropDown.js';
import NotificationBar from '@boschebike/ebds-react/dist-esm/components/NotificationBar.js';

/**
 * @typedef {import('../../App.d.ts').ComponentLegalDocumentProps} ComponentLegalDocumentProps
 */
/**
 * @param {ComponentLegalDocumentProps} props
 * @returns {React.js.Element}
 * @constructor
 */
export default ({
  contentRaw,
  locale,
  locales,
  languageSelectLabel,
  downloadButtonLabel,
  hasDownloadButton,
  pLangNotification,
}) => {
  const [pLangLink, setPLangLink] = useState('');

  useEffect(() => {
    const url = new URL(location.href);
    const pLang = url.searchParams.get('pLanguage');

    if (pLang) {
      url.searchParams.delete('pLanguage');

      const locLower = locale.toLowerCase();
      const [language] = locLower.split('-');
      const newLocale = (locales.find((l) => l.code.split('-')[0] === pLang))?.code.toLowerCase() ?? '';
      const isLocaleSpecificPage = url.pathname.includes(locLower);
      const isDiffLang = pLang.toLowerCase() !== language.toLowerCase();

      if (isDiffLang && newLocale && isLocaleSpecificPage) {
        const link = url.toString().replace(locLower, newLocale);
        setPLangLink(link);
      }
    }
  });

  return (
    <Container customContainerClassName="dodo-component-legal-document">
      <div data-testid="legal-document-controls" className="dodo-component-legal-document__controls">
        {hasDownloadButton && (
          <Button
            name="legal-download-button"
            href="?format=pdf"
            icon={<IconAsChunk iconName="documentpdf" />}
          >
            {downloadButtonLabel}
          </Button>
        )}
        <DropDown
          value={locale}
          label={languageSelectLabel}
          name="legal-language-select"
          onChange={(newLocale) => {
            const url = new URL(location.href);
            url.searchParams.delete('pLanguage');
            const { href, pathname } = url;
            const newHref = pathname.includes(locale.toLowerCase())
              ? href.replace(locale.toLowerCase(), newLocale.toLowerCase())
              : href.replace(pathname, `${pathname}/${newLocale.toLowerCase()}`);

            location.href = newHref;
          }}
          options={locales.map((loc) => ({
            label: loc.name,
            value: loc.code,
          }))}
        />
      </div>
      {pLangLink && (
        <NotificationBar
          type="info"
          icon="alertinfo"
        >
          <div
            dangerouslySetInnerHTML={{
              __html: pLangNotification.replace('pLangLink', pLangLink),
            }}
          />
        </NotificationBar>
      )}
      <div
        data-testid="legal-document"
        dangerouslySetInnerHTML={{
          __html: contentRaw,
        }}
      />
    </Container>
  );
};
